import React, { FC } from 'react';

import { IconButton } from '@chakra-ui/react';
import { Flex, Text } from '@chakra-ui/layout';

import { GrNext, GrPrevious } from 'react-icons/gr';

import { Pagination } from 'types/common';

const LIMITS_PER_PAGE = 10;

type Props = {
  pagination: Pagination;
  hasData: boolean;
};

const TablePagination: FC<Props> = ({ pagination, hasData }) => {
  if (pagination.totalCount <= LIMITS_PER_PAGE) {
    return null;
  }

  return (
    <Flex mt={10} align="center" justifyContent="flex-end">
      <IconButton
        aria-label="previous-page"
        icon={<GrPrevious />}
        isDisabled={pagination.page === 1}
        onClick={() => pagination.setPage((old) => old - 1)}
      />
      <Text mx={6}>
        {pagination.page} out of {Math.ceil(pagination.totalPages)}
      </Text>
      <IconButton
        aria-label="next-page"
        icon={<GrNext />}
        isDisabled={hasData ? pagination.totalPages <= pagination.page : true}
        onClick={() => pagination.setPage((old) => old + 1)}
      />
    </Flex>
  );
};

export default TablePagination;
